import { render, staticRenderFns } from "./InvoiceThankYou.vue?vue&type=template&id=4a03fd66&"
import script from "./InvoiceThankYou.vue?vue&type=script&lang=js&"
export * from "./InvoiceThankYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports